module.exports = __webpack_public_path__ + "images/fidget-spinner-34fab689228f3ce8c2e112afb8482135.png";